var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clientesConecta" },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.showInfoDialog,
            callback: function($$v) {
              _vm.showInfoDialog = $$v
            },
            expression: "showInfoDialog"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("Aplicaciones " + _vm._s(_vm.infoTypeReport))]
              )
            ],
            1
          ),
          _c("v-card", { attrs: { id: "bodyDialogInfo" } }, [
            _c(
              "div",
              { staticStyle: { "margin-left": "20px" } },
              _vm._l(_vm.infoItems, function(item) {
                return _c(
                  "div",
                  { key: item.index, staticClass: "itemInfoDiv" },
                  [
                    _c("li", [
                      _vm._v(
                        "\n            " + _vm._s(item.value) + "\n          "
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { sm12: "", md12: "" } },
        [
          _c("FiltrosBusqueda", {
            on: { resultadoBusqueda: _vm.filtroForm, clear: _vm.clearForm }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetalleModal", {
            attrs: { detalleSeleccionado: _vm.detalleSeleccionado },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }